import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function MarketArrowDownIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12 16.3198L19.6492 9.75903C20.3537 9.15471 19.9264 7.99999 18.9981 7.99999L5.00173 7.99993C4.07349 7.99993 3.64611 9.15466 4.3507 9.75898L12 16.3198Z",
    fill: "currentColor"
  }));
}